import { useState } from 'react';
import { exportData, ExportFilters, ExportOptions, ExportType } from '../utils/exportUtils';

export interface UseExportOptions {
  reportName: string;
  data: any[];
  filters: ExportFilters;
  tableDataTransformer?: () => any[];
}

export function useExport({ reportName, data, filters, tableDataTransformer }: UseExportOptions) {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async (format: 'xlsx' | 'csv', includeMetadata: boolean = true, exportType: ExportType = 'data') => {
    if (!data || data.length === 0) {
      alert('No data available to export.');
      return;
    }

    setIsExporting(true);
    
    try {
      const options: ExportOptions = {
        filename: reportName.replace(/\s+/g, '_').toLowerCase(),
        includeMetadata,
        format,
        exportType,
        tableDataTransformer
      };

      exportData(data, filters, options);
    } catch (error) {
      console.error('Export failed:', error);
      alert('Export failed. Please try again.');
    } finally {
      setIsExporting(false);
    }
  };

  return {
    isExporting,
    handleExport
  };
}
